// eslint-disable-next-line no-restricted-imports
import { initRum } from '@forto-dev/frontend-infra-logger'
import { config } from 'app/config'

// eslint-disable-next-line no-restricted-imports
export { addRumScope, removeRumScope } from '@forto-dev/frontend-infra-logger'

export const initRumWithDefaults = (): void => {
  if (config.DATADOG_RUM_ENABLED === 'true') {
    initRum({
      applicationId: config.DATADOG_RUM_APP_ID || '',
      clientToken: config.DATADOG_RUM_CLIENT_TOKEN || '',
      site: config.DATADOG_RUM_SITE || '',
      service: config.DATADOG_RUM_SERVICE || '',
      env: config.APP_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: config.COMMIT,
      sessionSampleRate: 100,
      sessionReplaySampleRate: config.DATADOG_RUM_SESSION_REPLAY_ENABLED ? 100 : 0,
      defaultPrivacyLevel: 'allow',
      trackUserInteractions: true,
      allowedTracingUrls: [
        window.location.origin,
        config.BOOKING_ENDPOINT,
        config.FX_CORE_ENDPOINT,
        config.DEM_DET_CORE_ENDPOINT,
        config.DOCUMENTS_CORE_V2_ENDPOINT,
        config.SHIPPING_ENDPOINT,
        config.USER_PROFILE_CORE_ENDPOINT,
        config.PARTNER_BOOKING_CORE_ENDPOINT,
        config.FEED_CORE_V2_ENDPOINT,
        config.NOTIFICATION_CENTER_ENDPOINT,
        config.TRANSPORT_UNITS_ENDPOINT,
        config.PUBLIC_API_ENDPOINT,
        config.QUOTATION_CORE_ENDPOINT,
        config.BILLING_CORE_ENDPOINT,
        config.CUSTOM_STATUS_ENDPOINT,
        config.CARBON_EMISSIONS_ENDPOINT,
        config.SUBSCRIPTIONS_ENDPOINT,
        config.CUSTOMER_MASTER_DATA_ENDPOINT,
      ],
    })
  }
}
